export default __webpack_public_path__ + "static/media/rpcoins.04b34e52.png";